/**
 * Chart colours for the Overview tab, by the job each one does.
 *
 * Booked and answered are the two series a reader compares, so they are the
 * two hues that pass the dataviz validator together (blue is the skill's
 * first categorical slot; green stays the product's booking colour). Calls
 * is context, drawn as a slate wash under the others. Voicemail, failed and
 * neutral are status colours: each always sits beside its own label.
 */
export const COLORS = {
  booked: "#16a34a",
  answered: "#2a78d6",
  calls: "#94a3b8",
  voicemail: "#d97706",
  failed: "#dc2626",
  neutral: "#64748b",
};

/** Chart chrome: recessive hairlines and muted axis text. */
export const CHROME = {
  grid: "#e5e7eb",
  axis: "#d1d5db",
  tick: "#6b7280",
  surface: "#ffffff",
};

export const AREA_FILL_OPACITY = 0.25;
export const LINE_WIDTH = 2;
export const BAR_RADIUS = [4, 4, 0, 0];
export const BAR_MAX_WIDTH = 24;
